export const isLoading = state => state.loadingProcesses > 0
export const images = state => state.finish ? state.finish.images : []
export const autoScroll = state => state.autoScroll
export const scrollSpeed = state => state.scrollSpeed
export const buttons = state => state.buttons